
const messages = {
  hello: 'hello world1'
}
export default messages